export default __webpack_public_path__ + "static/financial_report_2025-0d5e03e072d7790d960403cd773c09b1.pdf";